// You can write more code here

/* START OF COMPILED CODE */

/* START-USER-IMPORTS */
import { canAffordColor, cannotAffordColor } from '@/common/types/game';
import { Customization } from '@/common/types/student';
import { getCharacterInventory } from '@/game/GameComponents/PhaserGame/GameInstance';
import EventsManager from '@/game/GameComponents/PhaserGame/Managers/EventsManager';
import { ResponsivenessManager } from '@/game/GameComponents/PhaserGame/Managers/ResponsivenessManager';
import {
  getIconPath,
  getItemRarityTier,
  getPriceForItem,
  loadCustomizationTextures,
} from '@/game/GameComponents/PhaserGame/Utils/CosmeticUtils';
import GAME_EVENTS from '@/game/GameComponents/PhaserGame/Utils/gameEventsDef';
import { PhaserAudioManager } from '@/game/GameComponents/PhaserGame/Utils/PhaserAudioManager';
import { setBitmapColor } from '@/game/GameComponents/PhaserGame/Utils/PhaserUtils';
import { HOVER_CURSOR_PATH } from '@/game/GameComponents/Utils/GameSpriteAssetsMap';
/* END-USER-IMPORTS */

export default class ShopGridItem extends Phaser.GameObjects.Container {
  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 0, y ?? 0);

    // mobileView
    const mobileView = scene.add.container(0, 0);
    this.add(mobileView);

    // priceArea_m
    const priceArea_m = scene.add.container(32, 88);
    mobileView.add(priceArea_m);

    // priceBacking_m
    const priceBacking_m = scene.add.image(0, -30, 'priceBacking');
    priceBacking_m.scaleX = 2;
    priceBacking_m.scaleY = 2;
    priceBacking_m.setOrigin(0.5, 0);
    priceArea_m.add(priceBacking_m);

    // itemPrice_m
    const itemPrice_m = scene.add.bitmapText(0, -10, 'Aronui', '6500');
    itemPrice_m.setOrigin(0.5, 0.5);
    itemPrice_m.tintTopLeft = 11331187;
    itemPrice_m.tintTopRight = 11331187;
    itemPrice_m.tintBottomLeft = 11331187;
    itemPrice_m.tintBottomRight = 11331187;
    itemPrice_m.text = '6500';
    itemPrice_m.fontSize = -20;
    priceArea_m.add(itemPrice_m);

    // shopGridItemBacking_m
    const shopGridItemBacking_m = scene.add.image(0, 0, 'shopItemBacking-1');
    shopGridItemBacking_m.scaleX = 2;
    shopGridItemBacking_m.scaleY = 2;
    shopGridItemBacking_m.setOrigin(0, 0);
    mobileView.add(shopGridItemBacking_m);

    // rarityBorder_m
    const rarityBorder_m = scene.add.image(0, 0, 'shopItemBacking-2');
    rarityBorder_m.scaleX = 2;
    rarityBorder_m.scaleY = 2;
    rarityBorder_m.setOrigin(0, 0);
    mobileView.add(rarityBorder_m);

    // selectionOutline_m
    const selectionOutline_m = scene.add.image(0, 0, 'shopItemBacking-2');
    selectionOutline_m.scaleX = 2;
    selectionOutline_m.scaleY = 2;
    selectionOutline_m.setOrigin(0, 0);
    mobileView.add(selectionOutline_m);

    // itemImage_m
    const itemImage_m = scene.add.image(
      32,
      32,
      'ui-blue-chochular-hearing-aid-large',
    );
    mobileView.add(itemImage_m);

    // notificationIcon_m
    const notificationIcon_m = scene.add.image(6, 6, 'hud-icons', 240);
    notificationIcon_m.scaleX = 2;
    notificationIcon_m.scaleY = 2;
    mobileView.add(notificationIcon_m);

    // ruby_m
    const ruby_m = scene.add.image(32, 62, 'ruby-small');
    ruby_m.scaleX = 2;
    ruby_m.scaleY = 2;
    mobileView.add(ruby_m);

    // desktopView
    const desktopView = scene.add.container(0, 0);
    this.add(desktopView);

    // priceArea
    const priceArea = scene.add.container(64, 158);
    desktopView.add(priceArea);

    // priceBacking
    const priceBacking = scene.add.nineslice(
      0,
      -22,
      'priceBacking',
      undefined,
      24,
      20,
      4,
      4,
      4,
      4,
    );
    priceBacking.scaleX = 4;
    priceBacking.scaleY = 4;
    priceArea.add(priceBacking);

    // itemPrice
    const itemPrice = scene.add.bitmapText(0, -6, 'Aronui', '6500');
    itemPrice.setOrigin(0.5, 0.5);
    itemPrice.tintTopLeft = 11331187;
    itemPrice.tintTopRight = 11331187;
    itemPrice.tintBottomLeft = 11331187;
    itemPrice.tintBottomRight = 11331187;
    itemPrice.text = '6500';
    itemPrice.fontSize = -20;
    priceArea.add(itemPrice);

    // shopGridItemBacking
    const shopGridItemBacking = scene.add.image(0, 0, 'shopItemBacking-1');
    shopGridItemBacking.scaleX = 4;
    shopGridItemBacking.scaleY = 4;
    shopGridItemBacking.setOrigin(0, 0);
    desktopView.add(shopGridItemBacking);

    // rarityBorder
    const rarityBorder = scene.add.image(0, 0, 'shopItemBacking-2');
    rarityBorder.scaleX = 4;
    rarityBorder.scaleY = 4;
    rarityBorder.setOrigin(0, 0);
    desktopView.add(rarityBorder);

    // selectionOutline
    const selectionOutline = scene.add.image(0, 0, 'shopItemBacking-2');
    selectionOutline.scaleX = 4;
    selectionOutline.scaleY = 4;
    selectionOutline.setOrigin(0, 0);
    desktopView.add(selectionOutline);

    // itemImage
    const itemImage = scene.add.image(
      64,
      64,
      'ui-blue-chochular-hearing-aid-large',
    );
    itemImage.scaleX = 2;
    itemImage.scaleY = 2;
    desktopView.add(itemImage);

    // notificationIcon
    const notificationIcon = scene.add.image(16, 14, 'hud-icons', 240);
    notificationIcon.scaleX = 4;
    notificationIcon.scaleY = 4;
    desktopView.add(notificationIcon);

    // ruby
    const ruby = scene.add.image(64, 124, 'ruby-small');
    ruby.scaleX = 4;
    ruby.scaleY = 4;
    desktopView.add(ruby);

    this.itemPrice_m = itemPrice_m;
    this.priceArea_m = priceArea_m;
    this.shopGridItemBacking_m = shopGridItemBacking_m;
    this.rarityBorder_m = rarityBorder_m;
    this.selectionOutline_m = selectionOutline_m;
    this.itemImage_m = itemImage_m;
    this.notificationIcon_m = notificationIcon_m;
    this.ruby_m = ruby_m;
    this.mobileView = mobileView;
    this.itemPrice = itemPrice;
    this.priceArea = priceArea;
    this.shopGridItemBacking = shopGridItemBacking;
    this.rarityBorder = rarityBorder;
    this.selectionOutline = selectionOutline;
    this.itemImage = itemImage;
    this.notificationIcon = notificationIcon;
    this.ruby = ruby;
    this.desktopView = desktopView;

    /* START-USER-CTR-CODE */

    this.setNotificationVisible(false);
    this.setIsSelected(false);

    this.initializeResponsiveness();

    EventsManager.registerEventOn(
      this.scene,
      GAME_EVENTS.COIN_VALUE_CHANGED,
      this.refresh,
      this,
    );

    // // For testing
    // this.scene.events.on('postupdate', () => {
    //   // For debugging.
    //   if (this.debugGraphics) {
    //     this.debugGraphics.destroy();
    //   }
    //   this.debugGraphics = this.scene.add
    //     .rectangle(
    //       this.interactionWindow?.x,
    //       this.interactionWindow?.y,
    //       this.interactionWindow?.width,
    //       this.interactionWindow?.height,
    //     )
    //     .setStrokeStyle(2, 0xffff00);
    // });
    /* END-USER-CTR-CODE */
  }

  public itemPrice_m: Phaser.GameObjects.BitmapText;
  public priceArea_m: Phaser.GameObjects.Container;
  public shopGridItemBacking_m: Phaser.GameObjects.Image;
  public rarityBorder_m: Phaser.GameObjects.Image;
  public selectionOutline_m: Phaser.GameObjects.Image;
  public itemImage_m: Phaser.GameObjects.Image;
  public notificationIcon_m: Phaser.GameObjects.Image;
  public ruby_m: Phaser.GameObjects.Image;
  public mobileView: Phaser.GameObjects.Container;
  public itemPrice: Phaser.GameObjects.BitmapText;
  public priceArea: Phaser.GameObjects.Container;
  public shopGridItemBacking: Phaser.GameObjects.Image;
  public rarityBorder: Phaser.GameObjects.Image;
  public selectionOutline: Phaser.GameObjects.Image;
  public itemImage: Phaser.GameObjects.Image;
  public notificationIcon: Phaser.GameObjects.Image;
  public ruby: Phaser.GameObjects.Image;
  public desktopView: Phaser.GameObjects.Container;

  /* START-USER-CODE */

  cosmetic?: Customization;
  isSelected: boolean = false;
  interactionWindow?: Phaser.Geom.Rectangle;
  debugGraphics?: Phaser.GameObjects.Rectangle;

  onShopItemClicked?: (item: ShopGridItem) => void;
  onShopItemScrolled?: (event: any) => void;

  getResponsiveElements(key: keyof ShopGridItem) {
    return ResponsivenessManager.GetAllResponsiveComponentsFromContainer(
      this,
      key,
    );
  }

  setupInteraction(interactionWindow: Phaser.Geom.Rectangle) {
    this.setInteractivityWindow(interactionWindow);

    // Desktop interaction.
    this.shopGridItemBacking.setInteractive({
      cursor: `${HOVER_CURSOR_PATH}`,
      hitArea: this.shopGridItemBacking,
      hitAreaCallback: this.hitAreaCallback.bind(this),
    });

    // Remove existing interactions if any
    if (this.shopGridItemBacking.input) {
      this.shopGridItemBacking.removeAllListeners();
    }

    this.shopGridItemBacking.on('pointerover', () => {
      if (!this.isSelected) {
        this.shopGridItemBacking.setTexture('shopItemBacking-1-hover');
      }
      PhaserAudioManager.playSFX(this.scene, 'hover-click');
    });
    this.shopGridItemBacking.on('pointerout', () => {
      if (!this.isSelected) {
        this.shopGridItemBacking.setTexture('shopItemBacking-1');
      }
    });
    this.shopGridItemBacking.on('wheel', (event: any) => {
      this.onShopItemScrolled?.(event);
    });

    // Mobile interaction.
    this.shopGridItemBacking_m.setInteractive({
      cursor: `${HOVER_CURSOR_PATH}`,
      hitArea: this.shopGridItemBacking_m,
      hitAreaCallback: this.hitAreaCallback.bind(this),
    });

    // Remove existing interactions if any
    if (this.shopGridItemBacking_m.input) {
      this.shopGridItemBacking_m.removeAllListeners();
    }

    this.shopGridItemBacking_m.on('pointerover', () => {
      if (!this.isSelected) {
        this.shopGridItemBacking_m.setTexture('shopItemBacking-1-hover');
      }
      PhaserAudioManager.playSFX(this.scene, 'hover-click');
    });
    this.shopGridItemBacking_m.on('pointerout', () => {
      if (!this.isSelected) {
        this.shopGridItemBacking_m.setTexture('shopItemBacking-1');
      }
    });
    this.shopGridItemBacking_m.on('wheel', (event: any) => {
      this.onShopItemScrolled?.(event);
    });
  }

  refresh() {
    if (!this.cosmetic) return;
    const price = getPriceForItem(this.cosmetic.id);
    this.getResponsiveElements('itemPrice').forEach(
      (itemPrice: Phaser.GameObjects.BitmapText) => {
        itemPrice.setText(price.toString() || '0');
        const canAfford = getCharacterInventory().coins >= price;
        setBitmapColor(
          itemPrice,
          canAfford ? canAffordColor : cannotAffordColor,
        );
      },
    );
  }

  async setCosmeticData(cosmetic: Customization) {
    this.cosmetic = cosmetic;
    this.getResponsiveElements('itemImage').forEach(
      (itemImage: Phaser.GameObjects.Image) => {
        itemImage.setTexture(getIconPath(cosmetic));
      },
    );
    if (!this.scene.textures.exists(getIconPath(cosmetic))) {
      await new Promise<void>((resolve) =>
        loadCustomizationTextures(this.scene, cosmetic, () => resolve()),
      );
    }
    this.getResponsiveElements('itemImage').forEach(
      (itemImage: Phaser.GameObjects.Image) => {
        itemImage.setTexture(getIconPath(cosmetic));
      },
    );
    this.refresh();
    const id = cosmetic.id;
    const rarity = getItemRarityTier(id);
    if (rarity) {
      this.getResponsiveElements('rarityBorder').forEach(
        (rarityBorder: Phaser.GameObjects.Image) => {
          rarityBorder.setTint(parseInt(rarity.color));
        },
      );
    }
  }

  setPriceVisible(priceVisible: boolean) {
    this.getResponsiveElements('priceArea').forEach(
      (priceArea: Phaser.GameObjects.Container) => {
        priceArea.setVisible(priceVisible);
      },
    );

    this.getResponsiveElements('ruby').forEach(
      (ruby: Phaser.GameObjects.Image) => {
        ruby.setVisible(priceVisible);
      },
    );
  }

  setNotificationVisible(notificationVisible: boolean) {
    this.getResponsiveElements('notificationIcon').forEach(
      (notificationIcon: Phaser.GameObjects.Image) => {
        notificationIcon.setVisible(notificationVisible);
      },
    );
  }

  setIsSelected(isSelected: boolean) {
    this.isSelected = isSelected;
    this.getResponsiveElements('selectionOutline').forEach(
      (selectionOutline: Phaser.GameObjects.Image) => {
        selectionOutline.setVisible(isSelected);
      },
    );

    // Desktop
    this.shopGridItemBacking.setTexture(
      isSelected ? 'shopItemBacking-1-selected' : 'shopItemBacking-1',
    );

    // Mobile
    this.shopGridItemBacking_m.setTexture(
      isSelected ? 'shopItemBacking-1-selected' : 'shopItemBacking-1',
    );
  }

  setInteractivityWindow(interactionWindow: Phaser.Geom.Rectangle) {
    this.interactionWindow = interactionWindow;
  }

  hitAreaCallback(
    _hitArea: any,
    x: number,
    y: number,
    _gameObject: Phaser.GameObjects.GameObject,
  ) {
    const currentBacking = ResponsivenessManager.IsMobileDevice(this.scene)
      ? this.shopGridItemBacking_m
      : this.shopGridItemBacking;

    const worldMatrix = this.getWorldTransformMatrix();
    const worldPoint = worldMatrix.transformPoint(x, y);
    const itemWorldPos = worldMatrix.transformPoint(
      currentBacking.x,
      currentBacking.y,
    );

    // Create rectangle in world space
    const thisRect = new Phaser.Geom.Rectangle(
      itemWorldPos.x,
      itemWorldPos.y,
      currentBacking.width,
      currentBacking.height,
    );

    // Check if the point is within both the item's bounds and the interaction window
    const isInItemBounds = thisRect.contains(worldPoint.x, worldPoint.y);
    const isInWindow = this.interactionWindow?.contains(
      worldPoint.x,
      worldPoint.y,
    );

    return isInItemBounds && isInWindow;
  }

  getElementSize() {
    return new Phaser.Math.Vector2(
      this.shopGridItemBacking.displayWidth,
      this.shopGridItemBacking.displayHeight,
    );
  }

  initializeResponsiveness() {
    ResponsivenessManager.InitializeResponsiveBreakpoints({
      scene: this.scene,
      desktopView: this.desktopView,
      mobileView: this.mobileView,
    });
  }
  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
